<div class="header-search header-search-extended header-search-visible header-search-no-radius d-none d-lg-block">
    <a href="#" class="search-toggle" role="button">
        <i class="icon-search"></i>
    </a>
    <form action="#" method="get" (submit)="submitSearchForm($event)">
        <div class="header-search-wrapper search-wrapper-wide">
            <div class="select-custom">
                <select id="cat" name="cat" (change)="onCatSelect($event)" title="Categorie prodotto">
                    <option value="null">Tutte le categorie</option>
                    <option *ngFor="let item of categories;" [value]="item.CategoriaId">{{ item.Descrizione }}</option>
                  </select>
            </div>
            <label for="searchTerm" class="sr-only">Search</label>
            <input type="text" class="form-control" (input)="searchProducts($event)" name="searchTerm" id="searchTerm" placeholder="Cerca ..."
                required  />
            <button class="btn btn-primary" type="submit">
                <span class="sr-only">Search</span>
                <i class="icon-search"></i>
            </button>
        </div>

        <div class="live-search-list" *ngIf="searchTerm.length > 2">
            <div class="autocomplete-suggestions" *ngIf="suggestions.length > 0" (click)="goProductPage()">
                <a [routerLink]="'/product/default/' + product.slug" class="autocomplete-suggestion"
                    *ngFor="let product of suggestions">
                    <figure class="mb-0 mr-3" style="width: 40px; height: 40px;">
                        <molla-image [src]="product.sm_pictures && product.sm_pictures[0]?.url" width="40" height="40" alt="Product"
                            class="bg-transparent">
                        </molla-image>
                    </figure>

                    <div class="search-name" [innerHTML]="matchEmphasize(product.name) | safeContent"></div>
                    <span class="search-price">
                        <div class="product-price mb-0" *ngIf="product.minPrice == product.maxPrice else priceBlock">
                            {{ product.minPrice.toFixed(2) | currency:currVal }}</div>
                        <ng-template #priceBlock>
                            <div class="product-price mb-0" *ngIf="product.variants.length == 0 else limitBlock">
                                <span class="new-price">{{ product.minPrice.toFixed(2) | currency:currVal  }}</span>
                                <span class="old-price">{{ product.maxPrice.toFixed(2) | currency:currVal  }}</span>
                            </div>
                            <ng-template #limitBlock>
                                <div class="product-price mb-0">{{product.minPrice.toFixed(2) | currency:currVal}} - {{product.maxPrice.toFixed(2) | currency:currVal}}</div>
                            </ng-template>
                        </ng-template>
                    </span>
                </a>
            </div>
        </div>
    </form>
</div>